import * as client from "./client";
import * as queries from "./documents/queries";

export { default as configs } from "./configs";
export { client, queries };
